import { render, staticRenderFns } from "./ordinary.vue?vue&type=template&id=6cb4a76c&scoped=true&"
import script from "./ordinary.vue?vue&type=script&lang=js&"
export * from "./ordinary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb4a76c",
  null
  
)

export default component.exports